/*
 * File: OrderNote.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 09/17/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Maps through the order's notes and creates an order note component for each
 */

import React from "react";
import PropTypes from "prop-types";
import OrderNote from "./OrderNote";
import { Divider } from "@material-ui/core";

const OrderNoteList = ({ order }) => {
  return order.orderNotes.map((orderNoteModel, index) => {
    return (
      <React.Fragment key={index}>
        <OrderNote orderNoteModel={orderNoteModel} />
        <Divider />
      </React.Fragment>
    );
  });
};

OrderNoteList.propTypes = {
  order: PropTypes.object.isRequired
};

export default OrderNoteList;
